import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import { withDevice } from '@blazar-plugins/device'
import { SlickStyles, Dots, Dot } from './slickStyles'

import {
  StyledButton,
  ButtonContainer,
  CarouselWrapper,
  Separator,
  PreviousContainer,
  NextContainer,
} from './styled'

// More settings in react-slick documentation
const defaultSlickSettings = {
  arrows: false,
  dots: true,
  speed: 300,
  appendDots: Dots,
  customPaging: Dot,
}

const customTouchHandlerClass = 'carousel-touch-wrapper'

export class _ToplistingCarousel extends Component {
  componentDidMount() {
    window.addEventListener('touchstart', this.onTouchStart)
    window.addEventListener('touchmove', this.onTouchMove, { passive: false })
  }

  componentWillUnmount() {
    window.removeEventListener('touchstart', this.onTouchStart)
    window.removeEventListener('touchmove', this.onTouchMove, { passive: false })
  }

  /**
   * this onSwipe method is used to prevent unwanted need to double click Ad,
   * when the carousel has been swiped, see https://github.com/akiran/react-slick/issues/1298
   */
  onSwipe = () => {
    if (this.slider) {
      this.slider.innerSlider.clickable = true
    }
  }

  onTouchMove = (e) => {
    if (e) {
      const isEventInsideCarousel = e.target.closest(`.${customTouchHandlerClass}`)
      if (isEventInsideCarousel) {
        this.preventVerticalScrolling(e)
      }
    }
  }

  onTouchStart = (e) => {
    if (e) {
      this.firstClientX = e.touches[0].clientX
    }
  }

  preventVerticalScrolling = (e) => {
    const minValue = 5 // threshold

    this.clientX = e.touches[0].clientX - this.firstClientX

    // Vertical scrolling does not work when you start swiping horizontally
    if (Math.abs(this.clientX) > minValue) {
      e.preventDefault()
      e.returnValue = false
      return false
    }
    return true
  }

  next = () => {
    this.slider.slickNext()
  }

  previous = () => {
    this.slider.slickPrev()
  }

  render() {
    const { children, slickSettings = {}, device } = this.props
    // Disable swipe on large screens, as a temporary fix for issues when using mouse.
    const swipe = !device.is('large')

    if (!children || children.length < 1) {
      return null
    }

    return (
      <SlickStyles>
        <CarouselWrapper
          shouldHavePadding={children.length !== 1}
          className={customTouchHandlerClass}
        >
          <Slider
            ref={(refToSlider) => {
              this.slider = refToSlider
            }}
            {...{
              ...defaultSlickSettings,
              ...slickSettings,
              onSwipe: this.onSwipe,
              swipe,
            }}
          >
            {children}
          </Slider>
          {children.length > 1 && device.is('large') && (
            <ButtonContainer>
              <PreviousContainer>
                <StyledButton onClick={this.previous}>« Föregående</StyledButton>
              </PreviousContainer>
              <NextContainer>
                <StyledButton onClick={this.next}>Nästa »</StyledButton>
              </NextContainer>
            </ButtonContainer>
          )}
        </CarouselWrapper>
        <Separator />
      </SlickStyles>
    )
  }
}

_ToplistingCarousel.propTypes = {
  children: PropTypes.array,
  slickSettings: PropTypes.object,
  device: PropTypes.object.isRequired,
}

export default withDevice(_ToplistingCarousel)
